// Minimal .lrc parser
// Returns { lines: [{time:number, text:string}], synced:boolean }
// If no timestamps are found, returns plain text split by lines with time:null.

const TIME_TAG = /\[(\d{1,2}):(\d{1,2})(?:\.(\d{1,3}))?\]/g;

export function parseLrc(raw) {
  if (!raw || typeof raw !== "string") return { lines: [], synced: false };
  const out = [];
  let synced = false;

  raw.split(/\r?\n/).forEach((line) => {
    const stamps = [];
    let m;
    TIME_TAG.lastIndex = 0;
    while ((m = TIME_TAG.exec(line)) !== null) {
      const min = parseInt(m[1], 10);
      const sec = parseInt(m[2], 10);
      const ms = m[3] ? parseInt(m[3].padEnd(3, "0").slice(0, 3), 10) : 0;
      stamps.push(min * 60 + sec + ms / 1000);
    }
    const text = line.replace(TIME_TAG, "").trim();
    if (stamps.length > 0) {
      synced = true;
      stamps.forEach((t) => out.push({ time: t, text }));
    } else if (text.length > 0) {
      out.push({ time: null, text });
    }
  });

  if (synced) {
    out.sort((a, b) => {
      if (a.time === null) return 1;
      if (b.time === null) return -1;
      return a.time - b.time;
    });
  }

  return { lines: out, synced };
}

export function findActiveIndex(lines, currentTime) {
  if (!lines || lines.length === 0) return -1;
  let lo = 0,
    hi = lines.length - 1,
    ans = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    const t = lines[mid].time;
    if (t === null) {
      hi = mid - 1;
      continue;
    }
    if (t <= currentTime) {
      ans = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }
  return ans;
}
